import { Header } from '@/widgets/header'
import { Button } from '@/shared/ui'
import { designTokens } from '@/shared/lib/design-tokens'
import { typographyStyle } from '@/shared/lib/catalog'
import type { CSSProperties } from 'react'

type OnboardingPageMobileProps = {
  onContinue: () => void
  renewalSummaryLine: string
  reminderLine: string
}

const desktopTokens = designTokens.components.onboardingSuccess.desktop
const cardTokens = desktopTokens.card

const cardStyle: CSSProperties = {
  width: '100%',
  minHeight: cardTokens.height,
  borderRadius: cardTokens.borderRadius,
  padding: cardTokens.padding,
  borderColor: cardTokens.borderColor,
  borderWidth: designTokens.borders.widths.thin,
  borderStyle: designTokens.borders.styles.solid,
  background: cardTokens.background,
  boxShadow: cardTokens.shadow,
  backdropFilter: `blur(${cardTokens.backdropBlur})`,
  WebkitBackdropFilter: `blur(${cardTokens.backdropBlur})`,
}

const cardTitleStyle = {
  fontFamily: designTokens.typography.fontFamilies.primary,
  color: designTokens.colors.text.inverse,
  ...typographyStyle(designTokens.typography.body.lg, {
    fontWeight: 600,
  }),
}

const cardBodyStyle = {
  fontFamily: designTokens.typography.fontFamilies.primary,
  color: designTokens.colors.text.inverse,
  opacity: Number(cardTokens.textOpacity),
  ...typographyStyle(designTokens.typography.body.sm, {
    lineHeight: 'normal',
  }),
}

export function OnboardingPageMobile({
  onContinue,
  renewalSummaryLine,
  reminderLine,
}: OnboardingPageMobileProps) {
  return (
    <div className="flex w-full flex-1 flex-col items-center px-4 pb-8 xl:hidden">
      <Header className="flex" logoColor={designTokens.colors.text.inverse} />
      <div className="mt-16 w-full max-w-[560px] rounded-2xl border border-white/20 bg-black/35 p-6 backdrop-blur-sm">
        <h1
          style={{
            fontFamily: designTokens.typography.fontFamilies.primary,
            color: designTokens.colors.text.inverse,
            ...typographyStyle(designTokens.typography.onboarding.titleMobile),
          }}
        >
          Теперь вам доступны все преимущества подписки
        </h1>
        <p
          style={{
            marginTop: designTokens.spacing.md,
            fontFamily: designTokens.typography.fontFamilies.primary,
            color: designTokens.colors.text.inverse,
            opacity: 0.85,
            ...typographyStyle(designTokens.typography.body.md, {
              lineHeight: '130%',
            }),
          }}
        >
          {renewalSummaryLine}
          <br />
          {reminderLine}
        </p>
        <div className="mt-6 flex flex-col" style={{ gap: desktopTokens.cardsGap }}>
          <article style={cardStyle}>
            <h2 style={cardTitleStyle}>База знаний</h2>
            <p style={{ ...cardBodyStyle, marginTop: cardTokens.titleBodyGap }}>
              Экспертные доклады про рост метрик, маркетинг, дизайн, нейросети, управление командой
              - все, что поможет растить бизнес.
            </p>
          </article>
          <article style={cardStyle}>
            <h2 style={cardTitleStyle}>
              Бот комьюнити
              <br />и нетворкинг
            </h2>
            <p style={{ ...cardBodyStyle, marginTop: cardTokens.titleBodyGap }}>
              Мини-приложение с анкетами участников, чатом, Random Coffee и актуальными новостями.
            </p>
          </article>
        </div>
        <Button
          type="button"
          onClick={onContinue}
          variant="secondaryAssist"
          style={{
            marginTop: designTokens.spacing.xl,
            width: '100%',
            minHeight: '42px',
            borderRadius: designTokens.borders.radius.lg,
            backgroundColor: designTokens.colors.background.surface,
            color: designTokens.colors.neutral.ink,
            borderColor: designTokens.colors.background.transparent,
            ...typographyStyle(designTokens.typography.button),
          }}
        >
          Продолжить
        </Button>
      </div>
    </div>
  )
}
